import storage from '../services/storage';

/**
 * Filters products based on user's category from localStorage
 * @param {Array} products - Array of products from API response
 * @returns {Array} - Filtered products array
 */
export const filterProductsByUserCategory = (products) => {
  if (!Array.isArray(products)) {
    return [];
  }

  // Get user category from localStorage
  const user = storage.get("USUARIO")?.loginResponse;
  const userCategory = user?.profile?.categoria;

  if (!userCategory) {
    // If no user category found, return empty array for security
    return [];
  }

  return products.filter(product => {
    // If product doesn't have categoriasParticipantes or it's empty, show the product
    if (!product.categoriasParticipantes || product.categoriasParticipantes.length === 0) {
      return true;
    }

    // Check if user's category matches any of the product's participating categories
    const hasMatchingCategory = product.categoriasParticipantes.some(categoria => {
      return categoria.categoriaParticipante?.nomeCategoria === userCategory;
    });

    return hasMatchingCategory;
  });
};